import { render, staticRenderFns } from "./UserViewSidebarEdit.vue?vue&type=template&id=1b115a70&scoped=true&"
import script from "./UserViewSidebarEdit.vue?vue&type=script&lang=js&"
export * from "./UserViewSidebarEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserViewSidebarEdit.vue?vue&type=style&index=0&id=1b115a70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b115a70",
  null
  
)

export default component.exports